module.exports = __webpack_public_path__ + "img/14.009b15c8.png";